export const normalizeMaxDecimals = (numberOfDecimals: number) => {
  return (value: string, previousValue: string) => {
    let regex = new RegExp(`^-?[0-9]*[.,]?[0-9]{0,${numberOfDecimals}}$`)
    if (numberOfDecimals === 0) {
      regex = /^-?[0-9]*$/ // don't allow comma's or dots.
    }
    value = value.replace(/,/g, '.')
    if (!regex.test(value)) {
      value = previousValue
    }

    return value
  }
}
